import { Clock, Zap, BadgeCheck, PlugZap } from "lucide-react";

const ITEMS = [
    {
        icon: Clock,
        title: "Mehr Zeit fürs Kerngeschäft",
        text: "Routine läuft im Hintergrund. Ihr Team arbeitet wieder an Aufträgen und Kunden – statt an Postfach, Papierkram und Copy-Paste.",
        testid: "benefit-card-1",
    },
    {
        icon: Zap,
        title: "Antworten in Minuten statt Tagen",
        text: "Kunden bekommen auf Standardfragen sofort eine Antwort. Wer schnell reagiert, bleibt erste Wahl – und verliert keinen Auftrag an die Konkurrenz.",
        testid: "benefit-card-2",
    },
    {
        icon: BadgeCheck,
        title: "Weniger manuelle Fehler",
        text: "Was automatisiert erfasst und übertragen wird, verliert unterwegs keine Zahl, keinen Anhang und keinen Termin. Weniger Nacharbeit, weniger Ärger.",
        testid: "benefit-card-3",
    },
    {
        icon: PlugZap,
        title: "Keine IT-Umstellung nötig",
        text: "Kirenzo schließt sich an Ihre bestehenden Systeme an – E-Mail, Telefon, Kalender. Kein neues Tool für Ihr Team, keine Schulungswoche.",
        testid: "benefit-card-4",
    },
];

export const Benefits = () => (
    <section id="nutzen" className="py-20 lg:py-28 bg-[#111827] border-t border-white/[0.06] scroll-mt-16" aria-labelledby="benefits-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">Das Ergebnis</p>
            <h2 id="benefits-heading" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white max-w-2xl">
                Was sich konkret ändert – ohne Versprechen mit Sternchen.
            </h2>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                {ITEMS.map(({ icon: Icon, title, text, testid }) => (
                    <article
                        key={testid}
                        data-testid={testid}
                        className="flex gap-5 rounded-2xl border border-white/[0.08] bg-[#0B0F17] p-6 sm:p-8 transition-colors duration-200 hover:border-emerald-500/40"
                    >
                        <div className="shrink-0 flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20">
                            <Icon className="h-5 w-5 text-emerald-400" aria-hidden="true" />
                        </div>
                        <div>
                            <h3 className="text-lg sm:text-xl font-medium text-white">{title}</h3>
                            <p className="mt-2 text-sm text-[#9CA3AF] leading-relaxed">{text}</p>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
